import { Routes } from '@dtx-company/true-common/src/constants/routes'
import { UrlObject } from 'url'

export const CHANGE_BILLING_CYCLE_ROUTE: UrlObject = {
  pathname: Routes.ACCOUNT,
  query: {
    billing: '1',
    action: 'change-billing-cycle'
  }
}
